import React from "react"
import {Row, Col} from "antd"
import {useTranslation} from "react-i18next"
import StatisticCardItem from "./StatisticCardItem"
import styles from "./StatisticCards.module.css"
import {finAidRefundsService} from "services"
import {handleError} from "helpers"
import {FinAidRefundStats} from "types/fin-aid/refund"

type Props = {
    studentProfileId?: number
}

const StatisticCards: React.FC<Props> = ({studentProfileId}) => {
    const {t} = useTranslation(["financialAid"])
    const [stats, setStats] = React.useState<FinAidRefundStats>({
        pending: 0,
        requested: 0,
        refunded: 0,
        rejected: 0,
        total: 0
    })

    React.useEffect(() => {
        let cancelled = false
        const load = async () => {
            try {
                const data = await finAidRefundsService.getStats(
                    studentProfileId && Number.isFinite(studentProfileId) ? studentProfileId : undefined
                )
                if (!cancelled) setStats(data)
            } catch (e) {
                handleError(e)
            }
        }
        load()
        return () => {
            cancelled = true
        }
    }, [studentProfileId])

    return (
        <div className={styles.wrap}>
            <Row gutter={[24, 12]}>
                <Col span={6}>
                    <StatisticCardItem
                        title={t("refund.label.requested")}
                        value1={String(stats.requested)}
                        value2=""
                        icon="SHARE"
                        className="requested"
                    />
                </Col>
                <Col span={6}>
                    <StatisticCardItem
                        title={t("refund.label.refunded")}
                        value1={String(stats.refunded)}
                        value2=""
                        icon="CHECKMARK_CIRCLE"
                        className="refunded"
                    />
                </Col>
                <Col span={6}>
                    <StatisticCardItem
                        title={t("refund.label.rejected")}
                        value1={String(stats.rejected)}
                        value2=""
                        icon="CROSS_CIRCLE_FILL"
                        className="rejected"
                    />
                </Col>
                <Col span={6}>
                    <StatisticCardItem
                        title={t("refund.label.lastRefund")}
                        value1={String(stats.pending)}
                        value2={`Total ${stats.total}`}
                        icon="SEND"
                        className="lastRefund"
                        value1ClassName="small"
                    />
                </Col>
            </Row>
        </div>
    )
}

export default StatisticCards
